<template>
  <div class="deliveryPicker-info">
    <z-action-picker
      v-model="show"
      height="70vh"
      :title="title"
      :show-btn="false"
      @confirm="onConfirm"
    >
      <div v-for="(item, index) in infoData" :key="item.title + index" class="info-box">
        <div class="info-box__content">
          <div class="info-box__title">{{ item.title }}</div>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="info-box__desc" v-html="item.content"></div>
        </div>
      </div>
    </z-action-picker>
  </div>
</template>
<script>
  import Vue from 'vue'

  import { ActionPicker } from '@zz-common/zz-ui'
  Vue.use(ActionPicker)

  export default {
    components: {},
    props: {
      title: {
        type: String,
        default: '拆机检测说明',
      },
      infoData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        show: false,
      }
    },

    mounted() {
      console.log(this.title, 'sdfsdf')
      console.log(this.infoData, 'sdfsdf')
    },
    methods: {
      onConfirm() {},
      open() {
        this.show = true
      },
    },
  }
</script>

<style></style>

<style lang="scss">
  .deliveryPicker-info {
    max-height: 70vh;
    padding: 0 32px;

    .z-action-picker__title {
      height: 164px;
      font-family: PingFangSC, PingFang SC;

      background: url('https://pic3.zhuanstatic.com/zhuanzh/ec8bcdf0-66af-4660-8b68-4367e2b5fe6f.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title-text {
        font-size: 40px;
        font-weight: 500;
        color: #111111;
        position: relative;
        top: -16px;
      }
    }

    .z-action-picker__content {
      position: relative;
      top: -42px;
      padding: 0 32px 0 32px;
    }

    .info-box {
      // width: 686px;
      background: #f8f8f8;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 40px 32px;

      &__title {
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #111111;
        line-height: 28px;
      }

      &__desc {
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 300;
        color: #666666;
        line-height: 38px;
        margin-top: 20px;
      }
    }
  }
</style>
